import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
@Component({
  selector: 'app-desicion2',
  templateUrl: './desicion2.component.html',
  styleUrls: ['./desicion2.component.scss']
})
export class Desicion2Component implements OnInit {

  text;
  text2:string;

  constructor(
    public dialogRef: MatDialogRef<Desicion2Component>,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    let h3 = document.getElementsByTagName('H3').item(0);
    if(h3) this.text = h3.innerHTML;
    else this.text = data.title
    //console.log(this.text.innerText);
    this.text2 = data.text
  }
  ngOnInit(): void {}

}
